import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation
} from '@angular/core'

import { CommonModule } from '@angular/common'
import { TranslatePipe } from '@ngx-translate/core'
import { MatSidenavModule } from '@angular/material/sidenav'

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, TranslatePipe, MatSidenavModule]
})
export class FiltersComponent {
  @Output() applyFiltersEvent: EventEmitter<any> = new EventEmitter()
  @Output() resetFiltersEvent: EventEmitter<any> = new EventEmitter()
  constructor() {}
}
